export interface IRecoverSessionResult {
  success: boolean;
  error?: any;
}
